import { SegmentedControl } from '~/components/segmented-control/segmented-control';

interface ButtonTabsProps {
	tabs: { value: string; label: string }[];
	selectedTab: string;
	setSelectedTab: (tab: string) => void;
}

export const ButtonTabs = ({ tabs, selectedTab, setSelectedTab }: ButtonTabsProps) => {
	const segmentTabs = tabs.length > 1 ? tabs.map((tab) => ({ ...tab, key: tab.value })) : null;

	return (
		<>
			{segmentTabs && segmentTabs.length > 1 ? (
				<SegmentedControl
					id="segment-test"
					items={segmentTabs}
					activeItem={selectedTab}
					onChange={(e) => setSelectedTab(e.key)}></SegmentedControl>
			) : (
				<></>
			)}
		</>
	);
};
